export const ADMIN_ROUTE='/admin'
export const LOGIN_ROUTE='/login'
export const REGISTRATION_ROUTE='/registration'
export const GPT_TARO_ROUTE='/gpt-taro'
export const MAIN_ROUTE='/'
export const WITCH_ROUTE='/witch'
export const STUDIO_ROUTE='/studio'
export const USER_ACCOUNT_ROUTE='/user'
export const WHEEL_ROUTE='/wheel'

export const PRICE_ROUTE='/price'
export const MOBILE_ROUTE='/mobile'

export const PRIVARE_GADANIE_ROUTE='privateGadanie'


